module.exports = __webpack_public_path__ + "static/media/sonic bathtub.8960eb6b.jpg";